const defaultState = {
    version: "1.0.0"
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        default: return state;
    }
};